import { alpha, darken } from "@commonlibs";
import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const ButtonStyles = css(
    ({ theme: { spacing, palette, border, borderRadius, borderRounded } }) => css`
        .Button {
            transition: all 0.1s;
            text-transform: none;
            &:disabled {
                background-color: ${palette.disabled};
                color: ${darken(palette.disabled, 1)};
            }
            &.Loading {
                opacity: 1;
            }
            :active {
                box-shadow: none;
            }
            ${getTypographyStyle("body2Strong")}
        }

        .Button:not(.Text) {
            border-radius: ${borderRounded};
        }

        //Size styles
        .Button.Sm {
            padding: ${spacing.all(2, 3)};
            height: 2.25rem;
            .Icon {
                font-size: 1rem;
            }
        }

        .Button.Md {
            padding: ${spacing.all(2, 4)};
            height: 2.75rem;
            .Icon {
                font-size: 1.25rem;
            }
        }

        .Button.Lg {
            padding: ${spacing.all(2, 4.5)};
            height: 3.25rem;
            .Icon {
                font-size: 1.5rem;
            }
        }

        //Variant styles
        .Button.Primary:not(.Disabled) {
            background-color: ${palette.primary};
            color: ${palette.white};
            &:hover {
                background-color: ${darken(palette.primary, 0.15)};
            }
            &:active {
                background-color: ${darken(palette.primary, 0.3)};
            }
        }

        .Button.Outlined {
            border: ${border.md};
            color: ${palette.text};
        }
        .Button.Outlined:not(.Disabled) {
            &:hover {
                background-color: ${palette.overlays[300][12]};
            }
            &:active {
                background-color: ${palette.overlays[300][40]};
            }
        }

        .Button.Text:not(.Disabled) {
            border-radius: ${borderRadius};
            &:hover {
                background-color: ${alpha(palette.primary, 0.12)};
            }
            &:active {
                background-color: ${alpha(palette.primary, 0.2)};
            }
        }

        .Button.Secondary:not(.Disabled) {
            background-color: ${palette.secondary};
            color: ${palette.primary};
            &:hover {
                background-color: ${alpha(palette.secondary, 0.6)};
            }
            &:active {
                background-color: ${alpha(palette.secondary, 0.2)};
            }
        }

        .Button.Danger:not(.Disabled) {
            background-color: ${palette.status.error};
            color: ${palette.white};
            &:hover {
                background-color: ${alpha(palette.status.error, 0.9)};
            }
            &:active {
                background-color: ${alpha(palette.status.error, 0.8)};
            }
        }
    `,
);
